export default __webpack_public_path__ + "static/media/live.9446956f.png";